import { createContext, useContext } from "react"

import { AppliedScheme, DocumentThemeMode, ScannedArea } from "../types/local"

export const useTheme = () => {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error("useTheme must be used within a <ThemeProvider/>")
  }
  return context
}

interface ContextValue {
  scannedArea?: ScannedArea
  uiScheme: AppliedScheme
  setUIScheme: (scheme: AppliedScheme) => void
  setScannedArea: (scannedArea: ScannedArea) => void
  documentThemeMode: DocumentThemeMode
  setDocumentThemeMode: (mode: DocumentThemeMode) => void
}

export const ThemeContext = createContext<ContextValue | undefined>(undefined)

export function getQrLookupIDFromRoute({
  params,
  search,
}: {
  params: unknown
  search: unknown
}) {
  /*
    FML this is super sketch

    Using matches causes other things to break down stream
    for some fucking reason. I think fixing this will take
    some refactoring of how we manage themes which we frankly
    have no time for.
  */

  const qrParam =
    params &&
    typeof params === "object" &&
    "qrLookupID" in params &&
    typeof params.qrLookupID === "string"
      ? params.qrLookupID
      : null

  const qrSearch =
    search &&
    typeof search === "object" &&
    "qrLookupID" in search &&
    typeof search.qrLookupID === "string"
      ? search.qrLookupID
      : null

  return qrParam || qrSearch || null
}
